import { useNavigate, useLocation } from "react-router-dom";
import { Brain, Home, FileText, Tag, User } from "lucide-react";

const navItems = [
  { label: "Home", path: "/welcome", icon: Home },
  { label: "Intel", path: "/market-intelligence", icon: Brain },
  { label: "Scenarios", path: "/", icon: FileText },
  { label: "Account", path: "/account", icon: User },
  { label: "Pricing", path: "/pricing", icon: Tag },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string) => {
    if (path === "/") return pathname === "/";
    return pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border/50 bg-background/95 backdrop-blur-md safe-area-bottom">
      <div className="flex items-center justify-between h-14">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 min-w-0 px-0.5 h-full transition-colors ${
                active
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <Icon className="w-5 h-5 shrink-0" />
              <span className="text-[10px] font-medium leading-none max-w-full truncate">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
